export default "__VITE_ASSET__DgigaLjs__"